<p>Following are learning and training - Part 1</p>
<div>
    <p>
    <mat-button-toggle #toggleBtn checked>Toggle</mat-button-toggle> {{toggleBtn.checked}}
    </p>
    <p>
        <mat-button-toggle #toggleBtn checked disabled>Toggle Disables</mat-button-toggle> 
    </p>
    
    <p>
        Radio Button Example
        <mat-button-toggle-group  #toggleGroupRadio="matButtonToggleGroup">
          <mat-button-toggle value="bold">Bold</mat-button-toggle>
          <mat-button-toggle value="italic">Italic</mat-button-toggle>
          <mat-button-toggle value="underline">Underline</mat-button-toggle>
        </mat-button-toggle-group>
        {{toggleGroupRadio.value}}
      </p>
      <p>
        Check Box Example
        <mat-button-toggle-group  #toggleGroupCheckBox="matButtonToggleGroup" multiple>
          <mat-button-toggle value="Biology">Bilogy</mat-button-toggle>
          <mat-button-toggle value="Math">Math</mat-button-toggle>
          <mat-button-toggle value="Physics">Physics</mat-button-toggle>
        </mat-button-toggle-group>
        {{toggleGroupCheckBox.value}}
      </p>

</div>

<div>
    <p>
    <button mat-raised-button>Raised</button>
    <button mat-flat-button>Flat</button>
    <button mat-stroked-button>Stroked</button>
    <button mat-icon-button>Icon</button>
     </p>   

  <p>
    <button mat-fab>Fab</button>
    <button mat-mini-fab>Mini</button>
    </p>
</div>
<div>
    <button color="primary" mat-button>Primary</button>
    <button color="accent" mat-button>Accent</button>
    <button color="warn" disableRipple mat-button>Warn</button>

    <button color="primary" mat-raised-button>Primary</button>
    <button color="accent" mat-raised-button>Accent</button>
    <button color="warn"  mat-raised-button>Warn</button>
</div>


<!--
<app-hello-world></app-hello-world>
<date class="mat-display-1"></date>


<div class="mat-display-4">Material Typography</div>
<div class="mat-display-4">Size 4</div>
<div class="mat-display-3">Size 3</div>
<div class="mat-display-2">Size 2</div>
<div class="mat-headline">Headline</div>
<div class="mat-title">Title</div>
<div class="mat-subheading-2">Subheading 2</div>
<div class="mat-subheading-1">Subheading 1</div>
<div class="mat-typography">
    <h1>Within Typography Div</h1>
    <h1>H1</h1>
    <h2>H2</h2>
</div>

-->


